import {createApi} from '@reduxjs/toolkit/dist/query/react';
import customBaseQuery from './custom.base-query';
import {TInvestResponse, TNetwork, TProjectExternal, TProjectResponse, TToken} from './types';

const projectsApi = createApi({
  reducerPath: 'projectsApi',
  baseQuery: customBaseQuery,
  endpoints: builder => ({
    getPictureUrl: builder.query<{fileUrl: string}, string>({
      query: filename => ({
        url: `files/${filename}`,
        method: 'GET',
      }),
    }),
    getNetworks: builder.query<TNetwork[], void>({
      query: () => ({
        url: 'networks',
        method: 'GET',
      }),
    }),
    getProjectExternals: builder.query<TProjectExternal[], string>({
      query: id => {
        const filter: string = JSON.stringify({
          include: [{relation: 'network'}],
        });
        return {
          url: `projects/${id}/project-externals`,
          method: 'GET',
          params: {
            filter,
          },
        };
      },
    }),
    projectsById: builder.query<TProjectResponse, string>({
      query: id => {
        const filter: string = JSON.stringify({
          include: [
            {
              relation: 'projectExternals',
              scope: {
                include: [{relation: 'network'}],
              },
            },

            {
              relation: 'tokens',
              scope: {
                include: [{relation: 'network'}],
              },
            },
          ],
        });
        return {
          url: `projects/${id}`,
          method: 'GET',
          params: {
            filter,
          },
        };
      },
    }),
    createInvest: builder.mutation<TInvestResponse, TInvestResponse & {projectId: string}>({
      query: ({projectId, ...data}) => ({
        url: `projects/${projectId}/investments`,
        method: 'POST',
        body: data,
      }),
    }),
    getTokens: builder.query<TToken[], void>({
      queryFn: async (_arg, {getState}, extra, baseQuery) => {
        const filter: string = JSON.stringify({
          include: [{relation: 'network'}],
        });
        return (baseQuery as any)({
          url: 'tokens',
          method: 'GET',
          params: {
            filter,
          },
        });
      },
    }),
  }),
});

export const {
  useProjectsByIdQuery,
  useCreateInvestMutation,
  useGetTokensQuery,
  useGetProjectExternalsQuery,
  useGetNetworksQuery,
  useGetPictureUrlQuery,
} = projectsApi;

export default projectsApi;
